"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iterateFileByLine = void 0;
const fs_1 = require("fs");
const readline_1 = require("readline");
/**
 * Wykonywanie metody dla każdej linii w pliku
 *
 * @export
 * @param {string} file
 * @param {((line: string) => Promise<void> | void)} task
 * @returns {Promise<void>}
 */
async function iterateFileByLine(file, task) {
    const readStream = typeof file === 'string' ? (0, fs_1.createReadStream)(file) : file;
    const readline = (0, readline_1.createInterface)({ input: readStream });
    for await (const line of readline) {
        await task(line);
    }
}
exports.iterateFileByLine = iterateFileByLine;
//# sourceMappingURL=iterateFileByLine.js.map